import React, { useState, useRef, useEffect } from "react";
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FaSignOutAlt } from "@react-icons/all-files/fa/FaSignOutAlt";
import { FaBell } from "@react-icons/all-files/fa/FaBell";
import { FaTrash } from "@react-icons/all-files/fa/FaTrash";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import { environment } from "../../environments/environment";

const Navbar: React.FC<any> = ({
  setIsAuthenticated,
  collapsed,
  setCollapsed,
}) => {

  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);

  const notificationRef = useRef<HTMLDivElement>(null);

  // 🔔 FETCH NOTIFICATIONS
  const fetchNotifications = async () => {

    try {

      const token = localStorage.getItem("token");

      const res = await fetch(
        `${environment.apiBaseUrl}/get-all-admin-notifications`,
        {
          method: "GET",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      if (data?.success && Array.isArray(data.data)) {
        setNotifications(data.data);
      } else {
        setNotifications([]);
      }

    } catch (error) {

      // console.log("Notification error:", error);
      setNotifications([]);

    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // ✅ unread count
  const unreadCount = notifications.filter(
    (n) => n.status === "unRead"
  ).length;

  // ✅ MARK AS READ
  const markAsRead = async (id: number) => {

    try {

      const token = localStorage.getItem("token");

      await fetch(
        `${environment.apiBaseUrl}/notifications/read/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ remove unread count instantly
      setNotifications((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, status: "Read" }
            : item
        )
      );

    } catch (error) {

      // console.log("Mark read error:", error);

    }
  };

  // ✅ CLEAR SINGLE
  const clearSingleNotification = async (id: number) => {

    try {

      const token = localStorage.getItem("token");

      await fetch(
        `${environment.apiBaseUrl}/clear-notification/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ remove from UI
      setNotifications((prev) =>
        prev.filter((item) => item.id !== id)
      );

    } catch (error) {

      // console.log("Clear notification error:", error);

    }
  };

  // ✅ CLEAR ALL
  const clearAllNotifications = async () => {

    try {

      const token = localStorage.getItem("token");

      await fetch(
        `${environment.apiBaseUrl}/clear-all-notifications`,
        {
          method: "DELETE",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ clear UI
      setNotifications([]);

    } catch (error) {

      // console.log("Clear all error:", error);

    }
  };

  // click outside close
  useEffect(() => {

    const handleClickOutside = (event: MouseEvent) => {

      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target as Node)
      ) {
        setShowNotifications(false);
      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);

  }, []);

  const handleLogout = () => {

    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("token");

    setIsAuthenticated(false);
    setShowPopup(false);

    navigate("/login");

  };

  return (
    <div className={`navbar ${collapsed ? "collapsed-navbar" : ""}`}>

      {/* LEFT */}
      <div className="navbar-left">
        <button
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          <FaBars />
        </button>
      </div>

      {/* RIGHT */}
      <div className="navbar-right">

        {/* NOTIFICATIONS */}
        <div className="notification-wrapper" ref={notificationRef}>

          <button
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FaBell />

            {unreadCount > 0 && (
              <span className="notification-count">
                {unreadCount}
              </span>
            )}
          </button>

          {showNotifications && (
            <div className="notification-dropdown right-align">

              {/* ✅ CLEAR ALL */}
              {notifications.length > 0 && (
                <div
                  style={{
                    padding: "10px",
                    textAlign: "right",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <button
                    onClick={clearAllNotifications}
                    style={{
                      border: "none",
                      background: "red",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Clear All
                  </button>
                </div>
              )}

              {notifications.length > 0 ? (

                notifications.map((n) => (

                  <div
                    key={n.id}
                    className="notification-item"
                    style={{
                      background:
                        n.status === "unRead"
                          ? "#f5f9ff"
                          : "#fff",
                    }}
                  >

                    {/* ✅ CLICK => MARK AS READ */}
                    <div
                      onClick={() => markAsRead(n.id)}
                      style={{
                        cursor: "pointer",
                        flex: 1,
                      }}
                    >

                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        {n.title}
                      </div>

                      <div
                        style={{
                          fontSize: "12px",
                          color: "#666",
                        }}
                      >
                        {n.description}
                      </div>

                    </div>

                    {/* ✅ SINGLE DELETE */}
                    <button
                      onClick={() =>
                        clearSingleNotification(n.id)
                      }
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        color: "red",
                        marginLeft: "10px",
                      }}
                    >
                      <FaTrash />
                    </button>

                  </div>

                ))

              ) : (

                <div className="notification-item">
                  No new notifications
                </div>

              )}

            </div>
          )}
        </div>

        {/* WELCOME */}
        <span
          className="welcome-text"
          style={{ marginRight: "20px" }}
        >
          Welcome to Super Admin
        </span>

        {/* LOGOUT */}
        <a
          href="#!"
          className="logout"
          onClick={() => setShowPopup(true)}
        >
          <FaSignOutAlt />
          Logout
        </a>

      </div>

      {/* LOGOUT POPUP */}
      {showPopup && (

        <div className="popup-overlay">

          <div className="popup-box">

            <p>Are you sure you want to logout?</p>

            <div className="popup-actions">

              <button
                className="confirm-btn"
                onClick={handleLogout}
              >
                Yes
              </button>

              <button
                className="cancel-btn"
                onClick={() => setShowPopup(false)}
              >
                No
              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default Navbar;